<template>
  <div class="country_show">Show Country</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
